import Cookies from 'js-cookie';

export default {
  state: {
    user: null,
    token: Cookies.get('token'),
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      Cookies.set('token', token, { expires: 365 });
    },
    removeToken(state) {
      state.token = null;
      Cookies.remove('token');
    },
    setUser(state, user) {
      state.user = user;
    },
  },
  actions: {
    async login({ commit }, payload) {
      const data = await axios.post('oauth2/token', payload);
      commit('setToken', data.access_token);
    },
    async logout({ commit }) {
      await axios.post('api/logout');
      commit('removeToken');
      commit('setUser', null);
    },
    async fetchUser({ commit }) {
      const user = await axios.get('api/users/me');
      commit('setUser', user);
      return user;
    },
  },
};
